module.exports = __webpack_public_path__ + "static/media/skiply.31165dc0.png";